<template>
  <div>
    <a-modal
      :title='$t("page_plan_process_dispatch")'
      :visible="visible"
      :confirm-loading="loading"
      @cancel="handleCancel"
    >
      <div>
        <a-form-model :model="dataList">
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_production_plan_no') + ':'">
                <span>{{ dataList.planCode }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_collection_quantity') + ':'">
                <span>{{ dataList.collectionNum }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_process_name') + ':'">
                <span>{{ dataList.processName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_standard_process_procedure_code') + ':'">
                <span>{{ dataList.processCode }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_craft_Sequence') + ':'">
                <span>{{ dataList.processSequence }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_product_process_sequence') + ':'">
                <span>{{ dataList.sort }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_process_assigned_quantity') + ':'">
                <span>{{ dataList.assignNum }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_process_quantity_to_be_assigned') + ':'">
                <span>{{ dataList.unassignedNum }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div>
        <ml-table
          :columns="columns"
          :dataSource="data"
          :canChangeColWidth="true"
          :scroll="{ x: 500, y: 300 }"
        >
          <template slot="workStationName" slot-scope="text, record">
            <a @click="openDetail(record)">{{ text }}</a>
          </template>
          <template slot="assignDeptName" slot-scope="text, record">
            <a-tree-select
              v-model="record.assignDeptId"
              style="width: 100%"
              :tree-data="arr"
              show-search
              tree-node-filter-prop="title"
              @change="selectProducer(record)"
            />
          </template>
          <template slot="producerName" slot-scope="text, record">
            <a-select style="width: 100%" 
            show-search
            optionFilterProp="children"
            v-model="record.producerId">
              <a-select-option
                v-for="i in record.producerList"
                :key="i.id"
                :value="i.id"
              >
                {{ i.name }}
              </a-select-option>
            </a-select>
          </template>
          <template slot="assignNum" slot-scope="text, record">
            <a-input
              type="number"
              v-model="record.assignNum"
              @change="changeSum(record,text)"
              :min="0"
            />
          </template>
          <template slot="planStartTime" slot-scope="text, record">
            <a-date-picker
              v-model="record.planStartTime"
              type="date"
              style="width: 100%;"
            />
          </template>
          <template slot="planEndTime" slot-scope="text, record">
            <a-date-picker
              v-model="record.planEndTime"
              type="date"
              style="width: 100%;"
            />
          </template>
        </ml-table>
      </div>
      <div slot="footer">
        <a-row>
          <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-col :span="12">
              <a-form-model-item :label="$t('page_plan_process_total_assigned') + ':'">
                <span>{{ sum }}</span>
              </a-form-model-item>
            </a-col>
          </a-form-model>
          <a-col :span="12">
            <a-button @click="handleCancel" style="margin-top:5px"
              >{{$t("cancel")}}</a-button
            >
            <a-button
              @click="handleOk"
              style="margin-right:100px"
              type="primary"
              >{{$t("submit")}}</a-button
            >
          </a-col>
        </a-row>
      </div>
    </a-modal>
    <a-modal
      :title="title"
      :visible="DetailVisible"
      :confirm-loading="loading"
      @cancel="cancel"
    >
      <ml-table
        :columns="columnsList"
        :dataSource="dataDetail"
        :canChangeColWidth="true"
        :scroll="{ x: 500, y: 300 }"
      >
      </ml-table>
      <div slot="footer">
        <a-button @click="cancel" style="margin-top:5px">{{$t("cancel")}}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import {
  ProductionOrderProcessAssignServiceProxy,
  ProductionOrderProcessAssignRecordServiceProxy,
} from "@/service-proxies/app-v2/coproduction.service-proxies";
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies";
import dayjs from "dayjs";
const authorityDomainServiceProxy = new AuthorityDomainServiceProxy();
const productionOrderProcessAssignServiceProxy = new ProductionOrderProcessAssignServiceProxy();
const employeeServiceProxy = new EmployeeServiceProxy();
const productionOrderProcessAssignRecordServiceProxy = new ProductionOrderProcessAssignRecordServiceProxy();
export default {
  props: ["visible", "assignInfo", "poProcessId"],
  data() {
    return {
      loading: false,
      sum: 0,
      labelCol: { span: 12 },
      wrapperCol: { span: 8 },
      dataList: {
        planCode: "",
        processName: "",
        processCode: "",
        assignNum: "",
        unassignedNum: "",
        sort: null,
        processSequence: "",
      },
      data: [],
      dataDetail: [],
      DetailVisible: false,
      treeData: [],
      producerList: [],
      arr: [],
      title:""
    };
  },
  watch: {
    assignInfo: {
      handler(val) {
        if (val) {
          this.data = [];
          this.dataList.planCode = val.planCode;
          this.dataList.processName = val.processName;
          this.dataList.processCode = val.processCode;
          this.dataList.assignNum = val.assignNum;
          this.dataList.unassignedNum = val.unassignedNum;
          this.dataList.sort = val.sort;
          this.dataList.processSequence = val.processSequence;
          this.dataList.collectionNum = val.collectionNum;
          let arr = val.workStationInfo;
          arr.map((item) => {
            this.data.push(
              Object.assign({}, item, {
                assignNum: 0,
                planStartTime: "",
                planEndTime: "",
                assignDeptName: "",
                producerId: "",
                assignDeptId: "",
                producerName: "",
                producerCode: "",
                producerList: [],
              })
            );
          });
          console.log(8888, val);
        }
      },
    },
    visible: {
      handler(val) {
        if (val) {
          this.sum = 0;
          this.arr = [];
          this.treeList();
        }
      },
    },
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("page_qc_product_workstaion"),
          dataIndex: "workStationName",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "workStationName" },
        },
        {
          title: this.$t("page_plan_process_production_team"),
          dataIndex: "assignDeptName",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "assignDeptName" },
        },
        {
          title: this.$t("page_plan_process_production_personnel"),
          dataIndex: "producerName",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "producerName" },
        },
        {
          title: this.$t("page_plan_process_assigned_quantity"),
          dataIndex: "assignNum",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "assignNum" },
        },
        {
          title: this.$t("page_plan_process_quantity_already_sent"),
          dataIndex: "hasAssignNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_work_order_report_num"),
          dataIndex: "reportNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_plan_wait_report_num"),
          dataIndex: "unreportNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_collection_quantity"),
          dataIndex: "collectionNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_station_capacity"),
          dataIndex: "stationProductionCapacity",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_plan_predict_start_time"),
          dataIndex: "planStartTime",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "planStartTime" },
        },
        {
          title: this.$t("page_plan_predict_end_time"),
          dataIndex: "planEndTime",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "planEndTime" },
        },
      ];
    },
    columnsList() {
      return [
        {
          title: this.$t("page_plan_production_plan_no"),
          dataIndex: "planCode",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_product_name"),
          dataIndex: "productName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_order_no"),
          dataIndex: "orderCode",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_process_name"),
          dataIndex: "processName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_process_production_team"),
          dataIndex: "assignDeptName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_process_production_personnel"),
          dataIndex: "producerName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_plan_wait_report_num"),
          dataIndex: "unreportNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_collection_quantity"),
          dataIndex: "collectionNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_plan_process_total_assigned"),
          dataIndex: "totalNum",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_process_predict_endtime"),
          dataIndex: "planEndTime",
          ellipsis: true,
          width: 100,
          customRender: (time) =>
            time ? dayjs(time).format("YYYY-MM-DD HH:mm:ss") : "",
        },
      ];
    },
  },
  methods: {
    async treeList() {
      let res = await authorityDomainServiceProxy.treeList();
      this.treeData = res.data;
      this.treeData.map((item) => {
        this.arr.push({
          title: item.title,
          value: item.id,
          key: item.id,
          children: item.children,
        });
      });
      this.arr.map((item) => {
        this.selectTree(item.children);
      });
      console.log(44444, this.arr);
    },
    selectTree(record) {
      record.map((item) => {
        item.value = item.id;
        item.key = item.id;
        delete item.attribute;
        delete item.data;
        delete item.parentId;
        delete item.id;
        if (item.children.length > 0) this.selectTree(item.children);
      });
    },
    async getAssignListByWorkStation(id) {
      let res = await productionOrderProcessAssignServiceProxy.getAssignListByWorkStation(
        id
      );
      this.dataDetail = res;
      console.log(666, res);
    },
    async getEmployeeDeptList(record) {
      let res = await employeeServiceProxy.getEmployeeDeptList(record.assignDeptId);
      record.producerList = res;
      console.log(333, this.producerList);
    },
    async saveProcessAssignRecord() {
      let arr = [...this.data];
      arr.map((item,index) => {
        delete item.unreportNum;
        if (item.producerList&&item.producerList.length > 0) {
          item.producerList.map((items) => {
            if (item.producerId === items.id) {
              item.producerName = items.name;
              item.producerCode = items.code;
            }
          });
        }
        console.log(777, arr);
        if (item.planStartTime) {
          item.planStartTime = dayjs(item.planStartTime).format(
            "YYYY-MM-DD"
          );
        }
        if (item.planEndTime) {
          item.planEndTime = dayjs(item.planEndTime).format(
            "YYYY-MM-DD"
          );
        }
        if (item.assignNum) {
          item.assignNum = parseInt(item.assignNum);
        }
        this.treeSearchName(item, this.arr);
      });

      let a = arr.filter(items => items.assignNum!=0)
      
      let params = {
        noAssignNum: this.assignInfo.unassignedNum,
        poProcessId: this.poProcessId,
        workStationAssignDTOList: a,
      };
      console.log(777, this.data);
      await productionOrderProcessAssignRecordServiceProxy.saveProcessAssignRecord(
        params
      ).then((res) =>{this.$emit("closeDispatch");this.$message.success("派工成功")});        
    },
    treeSearchName(item, arr) {
      arr.map((tree) => {
        if (item.assignDeptId === tree.value) {
          item.assignDeptName = tree.title;
        }
        if (tree.children.length > 0) {
          this.treeSearchName(item, tree.children);
        }
      });
    },
    selectProducer(record) {
      record.producerId = ""
      this.getEmployeeDeptList(record);
      console.log(99999, record);
    },
    changeSum(record,i) {
      if(parseInt(i)<0) 
      {record.assignNum = 0}
      this.sum = 0;
      let a = 0
      this.data.map((item) => {
        a = item.assignNum
        if(item.assignNum==="") a = 0
        this.sum = parseInt(a) + this.sum;
      });
    },
    handleOk() {
      this.saveProcessAssignRecord();
    },
    handleCancel() {
      this.$emit("closeDispatch");
    },
    cancel() {
      this.DetailVisible = false;
    },
    openDetail(record) {
      this.title = record.workStationName
      this.getAssignListByWorkStation(record.workStationId);
      this.DetailVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-row .ant-form-item {
  display: flex;
}
/deep/ .ant-modal-content {
  width: 1000px;
  margin-left: -100px;
}
</style>
